import {createFileRoute} from '@tanstack/react-router'

import {ThirdPartyRentalAssetOfferingsPage} from '../../../../assets/rental-assets/third-party-rental-asset-offerings-page'

export const Route = createFileRoute('/_app/rental-assets/offerings/')({
    component: ThirdPartyRentalAssetOfferingsRoute,
})

function ThirdPartyRentalAssetOfferingsRoute() {
    return <ThirdPartyRentalAssetOfferingsPage />
}
